export const generateMockData = (count: number) => {
  const mockData = [];
  for (let i = 1; i <= count; i++) {
    mockData.push({
      heading: `Module ${i}`,
      progress: (Math.floor(Math.random() * count) + 1) * (100 / (count - 1)),
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis posuere arcu, nec convallis risus. Donec sit amet tristique nisi. Vivamus placerat libero quis urna feugiat imperdiet. In sed fermentum sapien. Ut aliquet interdum mauris, ac cursus diam posuere ut. Suspendisse potenti. ',
      colorScheme: 'teal',

      hasIconButton: true,
      button: {
        children: 'startButton',
        onClick: () => {
          console.log('Clicked');
        },
      },
    });
  }
  return mockData;
};
export const fetchData = (): Promise<[]> => {
  return new Promise(resolve => {
    setTimeout(() => {
      const mockData = generateMockData(35);
      resolve(mockData as []);
    }, 1000);
  });
};
